// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__1gUQF","switch":"Toggle_switch__1I1re","slider":"Toggle_slider__2-AWQ","round":"Toggle_round__32pHK"};